
import Utils from '../Utils';
import Paper from 'material-ui/Paper';
import {cyan500} from 'material-ui/styles/colors';
import * as MediaQuery from 'react-responsive';
import * as React from 'react';

const styles = {
    section : {
        width: '100%',
        height:'100%',
        position: 'fixed',
        backgroundColor: cyan500,
        display: 'flex',
        maxWidth: 'none',
    },
    header: {
      margin: '5% auto',
      color: 'white',
      background: 'url(../../../assets/images/logo_white.png) no-repeat',
      backgroundSize: '40px',
      paddingLeft: '50px',
      backgroundPositionX: '0px',
      fontSize: '34px',
      lineHeight: '40px',
      textAlign: 'center',
    },
    headerMobile: {
      color: 'white',
      background: 'url(../../../assets/images/logo_white.png) no-repeat',
      backgroundSize: '40px',
      paddingTop: '50px',
      backgroundPositionX: 'center',
      backgroundPositionY: '0px',
      fontSize: '34px',
      lineHeight: '40px',
      textAlign: 'center',
    },
    paper : {
        padding: '3%',
        textAlign: 'center',
        display: 'block',
        resize: 'verticle',
    },
};

interface Props {

}

interface State {
 
}


class Welcome extends React.Component<Props, State> {
    constructor(props: Props) {
        super(props);
    }

    render() {
        // console.log('New login component')
        const loginCard = (
                <Paper style={styles.paper} zDepth={3}>
                    <h3> Checking your login state ...</h3>
                </Paper>
            );
                        
        return (
                <section style={styles.section}>
                    <MediaQuery query='(min-device-width: 1224px)'>
                        <div style={{
                                display:'flex',
                                flexDirection: 'column',
                                justifyContent: 'flex-start',
                                resize: 'verticle',
                                width: '30%',
                                height: '70%',
                                margin: 'auto',
                            }}>
                            <h1 style={styles.header}> Glance For {Utils.getDomainPrefix()}</h1>
                            {
                                loginCard
                            }
                        </div>
                    </MediaQuery>
                    <MediaQuery query='(max-device-width: 1224px)'>
                        {
                            (matches) => {
                                if (matches) {
                                    console.log('mobile device');
                                    return (
                                        <div style={{
                                            display:'flex',
                                            flexDirection: 'column',
                                            justifyContent: 'flex-start',
                                            resize: 'verticle',
                                            width: '90%',
                                            height: '90%',
                                            margin: 'auto',
                                            overflow: 'auto',
                                        }}>
                                            <h1 style={styles.headerMobile}> Glance For {Utils.getDomainPrefix()}</h1>
                                            {
                                                loginCard
                                            }
                                        </div>
                                    );
                                } else {
                                    return null;
                                }
                            }
                        }
                       
                    </MediaQuery>
                </section>
        );
    }
}

export default Welcome;



// WEBPACK FOOTER //
// ./src/components/Welcome.tsx